import { GoogleTagManagerEvents } from "@faire/retailer-visitor-shared/services/tracking/googleTagManagerEvents";

export const initializeGTM = () => {
  GoogleTagManagerEvents.get();
};
